import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
//
//import DeliveryLocations from './../Components/DeliveryLocations'
//
import AccountResources from './../Account/Resources/commonfunctions.js';

//
let service = new services();

export default {
    name: 'MakeOrder',
    mixins: [AccountResources],
    data () {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints:{},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error:false,
            group_isset:false,
            add_sellpoint: false,
            add_business: false,
            get_flag:false,
            loading:false,
            action_loading:false,

            //messages
            validate_user_name_message: "",
            payment_successful_message:"",
            data_error_message: "",
            data_boarding_message: "",
            //
            headerdata:{
                'name':'Set Order',
            },

            //
            order_data:{},
            select_delivery_location:0,
            set_delivery_location:{},
            reset_order:false,
            //
            set_view_box:'',
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
       // 'component-delivery-locations': DeliveryLocations
    },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages(){
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },

        preset() {
            this.loading = true;
            //../
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                }else {
                    self.loading = false;
                    //self.$router.push('/login')
                }
            });
            
        },

        //
        setProduct(){ 
            this.loading = true;
            this.set_order_data.order_total_amount = 0;//ini
            service.getProductSearch(this, this.$route.params.ref).then(response => {
                if(response.body.status == 200) {
                    this.product = response.body.data;
                    //set display image
                    if(Object.keys(this.product.product_images).length > 0){
                        this.product_display_image = this.product.product_images[0];
                    }else{
                        this.product_display_image.product_image = "";
                    }
                    this.product_item = this.product.product_items[0];
                    this.product.product_price = this.product_item.product_item_price;
                    this.set_order_data.order_total_amount = Number(this.product.product_price);
                    this.set_order_total_amount = this.set_order_data.order_total_amount;
                    //
                    this.processMakeOrder();
                    if(this.product.product_item_groups.length != 0){
                        this.product_item_group = this.product.product_item_groups[0];
                    }else{
                        this.product_item_group = [];
                    }

                    //
                    this.sellpoint.business_id = this.product.product_business_id;
                    this.sellpoint.business_username = this.product.product_business_ownername;
                    this.setBusinessDetails();
                    
                    //get products for addons
                    //this.getProductAddons(this.product);
                    //set for prep selected addons
                    this.product.selected_product_addons = [];
                    
                }
            }).catch((err) => {
                // console.log(err)
             //   this.redir(this.$route.params.id1); //go to sellpoint
                //log it
                //location.replace("/")
            })
        },

        setBusinessDetails(){
            service.getBusinessByUserName(this, this.sellpoint.business_username).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data; 
                    //setts
                    //----------delivery-locations
                    this.business_delivery_locations = this.sellpoint.business_delivery_options;
                    //----------./delivery-locations

                    //----------bank-details
                    this.business_bank_details = this.sellpoint.business_bank_details;
                    //----------./bank-details
                } 
            }).catch((err) => {})
        },

        setViewBox(view){
            this.setMenuTabInnerView('setOptions');
            //
            this.set_view_box = view;
            //this.toggleSingleComponent(view);
        },

},
created: function(){
    this.setProduct();
    this.preset();
    //
    this.getRavepayBanks();
}
}



// WEBPACK FOOTER //
// ./src/pages/MakeOrder/script.js